import React from 'react';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { Link } from 'core/routing';
import { Date } from 'apps/components/date';
import { Button, Heading, OverflowTooltip } from 'components';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import {
  MainShareCardWrapper,
  ImageWrapper,
  DateBlockWrapper,
  ActionsWrapper,
} from 'apps/share/blocks/shareCard.styles';
import { SpaceLink } from '../../shared';
import { ShareItemProps, useCommonShare } from './common';

export const ShareFileListItem = (props: ShareItemProps) => {
  const { cardObject } = props;
  const {
    image,
    noMargin,
    handleMouseOver,
    handleMouseLeave,
    handleDeleteBtn,
    isVisible,
    creatorSpace,
    shouldShowDelete,
  } = useCommonShare(props);

  if (cardObject === null) {
    return <CardIndicator noMargin={noMargin} type='sharedFile' />;
  }

  return (
    <MainShareCardWrapper
      onMouseLeave={handleMouseLeave}
      onMouseOver={handleMouseOver}
      style={{ width: '100%' }}
    >
      <ImageWrapper>
        <img
          src={imageSrc(
            image,
            cardObject?.imageFallbackPath,
            mainConf?.imgSizes?.project?.card,
          )}
          alt='CAD model thumbnail'
        />
      </ImageWrapper>
      <div className='flex justify-between items-center w-full'>
        <div className='flex flex-col justify-center m-4 h-full w-80'>
          <Link
            {...cardObject?.route}
            openTab={{
              title: cardObject?.name,
              iconType: 'file',
            }}
          >
            <Heading
              variant={isVisible ? 'secondary' : 'primary'}
              margin='0 0 small 0'
              singleLine
              level='3'
            >
              <OverflowTooltip text={cardObject?.name} />
            </Heading>
          </Link>
          <SpaceLink
            space={cardObject?.space}
            creatorSpace={creatorSpace}
            preferWorkspaceLink
          />
        </div>
        <Heading singleLine level='5' weight='regular'>
          Version {cardObject?.revisionCount}
        </Heading>
        <DateBlockWrapper style={{ width: 180, overflowX: 'auto' }}>
          <Date
            className=' text-left'
            value={cardObject?.revision?.lastUpdated}
          />
        </DateBlockWrapper>
        <div style={{ width: 166 }} className='flex justify-end'>
          <ActionsWrapper isVisible={isVisible}>
            {shouldShowDelete && (
              <Button
                ariaLabel='Delete this Shared File'
                onClick={handleDeleteBtn}
                variant='destructive'
                size='small'
                outline
                icon='delete'
                style={{ marginLeft: 16 }}
              />
            )}
            <Link
              {...cardObject?.route}
              openTab={{
                title: cardObject?.name,
                iconType: 'file',
              }}
            >
              <Button
                size='small'
                outline
                variant='primary'
                text='Open'
                icon='arrow_right'
                iconPosition='right'
              />
            </Link>
          </ActionsWrapper>
        </div>
      </div>
    </MainShareCardWrapper>
  );
};
